import React from 'react';

import { configuration } from '@/external/config';
import { keycloak } from '@/Routing/keycloak';

export const useLogout = (): VoidFunction => {
  return React.useCallback((): void => {
    keycloak
      .logout({
        redirectUri: configuration.logoutUrl,
      })
      .catch(console.debug);
  }, []);
};
